import React, { useState } from 'react'
import {
    Card, CardBody, CardHeader, CardTitle, FbCheckbox,
    GridContainer,
    GridItem,
} from '@fabricks/ui-components'
import PackagetypesTable from "../Packagetypes/PackagetypesTable";
import { HR } from "../../components/Common/Common";
import { FilterParam } from "../../api/models";
import { useQuery } from "@apollo/react-hooks";
import { useLocation } from "react-router-dom";

interface PackagetypesPageProps {
}

interface Filter {
    isInvalid: boolean | null
}

export const Packagetypes: React.FC<PackagetypesPageProps> = (props: PackagetypesPageProps) => {
    const [jumpToPage, setJumpToPage] = useState()
    const [filter, setFilter] = useState<Filter>({
        isInvalid: new URLSearchParams(useLocation().search).get('filter') === 'isInvalid'
    })

    const handleInvalidPackageTypeFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, isInvalid: event.target.checked})
        setJumpToPage(0)
    }

    const createFilterParams = () => {
        const filterParams: FilterParam[] = []
        if (filter.isInvalid === true) {
            filterParams.push({ custom: 'isInvalid' })
        }
        return filterParams
    }

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <FbCheckbox
                    id="storageNumberFilter"
                    label="Invalid package types"
                    checked={filter.isInvalid || false}
                    onChange={handleInvalidPackageTypeFilterChange}
                />
                <HR />
                <PackagetypesTable jumpToPage={jumpToPage} filter={createFilterParams()} />
            </GridItem>
        </GridContainer>
    )
}
